import React, { createContext, useContext, useState, useEffect } from 'react';
import APIClient from '../../../lib/api';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('access_token');
    if (token) {
      // Validate token by making a test request
      APIClient.clients.getAll({ limit: 1 })
        .then(() => {
          setIsAuthenticated(true);
          setUser({ username: 'admin' }); // You can fetch user info here
        })
        .catch(() => {
          localStorage.removeItem('access_token');
          setIsAuthenticated(false);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (credentials) => {
    try {
      const response = await APIClient.auth.login(credentials);
      const { access_token } = response.data;
      
      if (!access_token) {
        return { 
          success: false, 
          error: 'Δεν λήφθηκε token από τον διακομιστή' 
        };
      }
      
      localStorage.setItem('access_token', access_token);
      setIsAuthenticated(true);
      setUser({ username: credentials.username });
      
      return { success: true };
    } catch (error) {
      console.error('Login error:', error);
      return { 
        success: false, 
        error: error.response?.data?.detail || error.message || 'Σφάλμα σύνδεσης' 
      };
    }
  };

  const logout = () => {
    localStorage.removeItem('access_token');
    setIsAuthenticated(false);
    setUser(null);
  };

  const value = {
    isAuthenticated,
    user,
    loading,
    login,
    logout,
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};